import { Injectable } from '@angular/core';

import { BaseService } from './base.service';
import { DynamicListModel } from '../model/dynamic-list.model';
import { DynamicListFieldRawModel } from '../model/dynamic-list-field-raw.model';
import { DynamicListFieldOptionsModel } from '../model/dynamic-list-field-options.model';

type FieldType = DynamicListFieldRawModel | DynamicListFieldOptionsModel;

@Injectable()
export class DynamicListService {

  path = '/dynamic-list/';
  pathItem = '/dynamic-list-item/';
  pathRaw = '/dynamic-list-field-raw/';
  pathOption = '/dynamic-list-field-options/';

  constructor(private baseService: BaseService) {}

  getPaginated(query) {
    return this.baseService.get(this.path, '', query);
  }

  getItemsPaginated(query) {
    return this.baseService.get(this.pathItem, 'grouped', query);
  }

  getPaginatedFieldRaw(query) {
    return this.baseService.get(this.pathRaw, '', query);
  }

  getPaginatedFieldOptions(query) {
    return this.baseService.get(this.pathOption, '', query);
  }

  findByPk(id: string) {
    return this.baseService.get(this.path, id);
  }

  post(list: DynamicListModel) {
    return this.baseService.post(this.path, '', list);
  }

  put(list: DynamicListModel) {
    return this.baseService.put(this.path, '', list);
  }

  deleteList(id: string) {
    return this.baseService.delete(this.path, id);
  }

  deleteFieldRaw(id: string) {
    return this.baseService.delete(this.pathRaw, id);
  }

  deleteFieldOption(id: string) {
    return this.baseService.delete(this.pathOption, id);
  }

  saveList(list: DynamicListModel) {
    if (list.id) return this.put(list); else return this.post(list);
  }

  // Fields

  postField(field: FieldType) {
    return this.baseService.post(this.getPath(field), '', field);
  }

  putField(field: FieldType) {
    return this.baseService.put(this.getPath(field), '', field);
  }

  deleteField(field: FieldType) {
    return this.baseService.delete(this.getPath(field), field.id + '');
  }

  getPath = (field) => field && field.list_resp_type_id ? this.pathOption : this.pathRaw;

  saveField(field: FieldType) {
    if (field.id) return this.putField(field); else return this.postField(field);
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/dynamic-list.service.ts